import React from 'react';
import PropTypes from 'prop-types';
import Countdown from 'react-countdown';

const CountdownTimer = ({ date, renderer }) => {
  return <Countdown date={date} renderer={renderer} />;
}

CountdownTimer.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  renderer: PropTypes.func.isRequired,
};

export default CountdownTimer;